var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletionHist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6663 20.261C25.6663 21.274 25.3935 22.2301 24.8933 23.0496C23.9612 24.609 22.2447 25.6675 20.2668 25.6675C19.1982 25.6675 18.1979 25.3488 17.3567 24.7911C16.6519 24.3586 16.0721 23.7553 15.6515 23.0496C15.1514 22.2301 14.8672 21.274 14.8672 20.261C14.8672 17.2789 17.2885 14.8545 20.2668 14.8545C20.676 14.8545 21.0738 14.9 21.449 14.9911C23.8702 15.526 25.6663 17.6886 25.6663 20.261Z",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6544 21.1613L20.2692 20.663L19.1086 18.0548",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1392 21.4672L9.72128 21.4671C8.09573 21.4671 6.53837 20.1467 6.26555 18.5418L4.75368 9.48169M20.5215 9.48169L20.1693 12.5322",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58594 5.71386L8.83602 4.2228C9.0179 3.1415 9.15431 2.33337 11.0754 2.33337H14.0537C15.9748 2.33337 16.1226 3.18703 16.2931 4.23419L16.5432 5.71386",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7955 6.86403C19.0101 6.48842 15.202 6.29492 11.4053 6.29492C9.1545 6.29492 6.90373 6.40874 4.65296 6.63639L2.33398 6.86403",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletionHist);
export default __webpack_public_path__ + "static/media/deletion_hist.e8b7beb213251d780b40c24980272ae4.svg";
export { ForwardRef as ReactComponent };